module.exports = __webpack_public_path__ + "static/media/Portrait-10222.3fb0956e.jpg";